import {
  ColumnFilter,
  GridSort,
} from '../../table/components/table/table.types';

export enum GridDataSourceMode {
  standby = 'standby',
  loading = 'loading',
  loaded = 'loaded',
  error = 'error',
}

export interface GridDataParams {
  page: number;
  pageSize: number;
  filter: ColumnFilter;
  sort: GridSort;
}

export interface GridData<T> {
  rowData: T[];
  rowCount: number;
}

export type GridDataSourceState<T> =
  | {
      mode: GridDataSourceMode.standby;
      dataParams: GridDataParams;
    }
  | {
      mode: GridDataSourceMode.loading;
      dataParams: GridDataParams;
    }
  | {
      mode: GridDataSourceMode.loaded;
      dataParams: GridDataParams;
      data: GridData<T>;
    }
  | { mode: GridDataSourceMode.error; dataParams: GridDataParams };

export const GridDataSourceState = {
  standBy: <T>(dataParams: GridDataParams): GridDataSourceState<T> => ({
    mode: GridDataSourceMode.standby,
    dataParams,
  }),
  loading: <T>(dataParams: GridDataParams): GridDataSourceState<T> => ({
    mode: GridDataSourceMode.loading,
    dataParams,
  }),
  loaded: <T>(
    dataParams: GridDataParams,
    data: GridData<T>,
  ): GridDataSourceState<T> => ({
    mode: GridDataSourceMode.loaded,
    data,
    dataParams,
  }),
  error: <T>(dataParams: GridDataParams): GridDataSourceState<T> => ({
    mode: GridDataSourceMode.error,
    dataParams,
  }),
};
